
class FiltroBuscarFactory  {

	constructor() {
		this._filtro = {};
    
	}
	limpiarFiltro () {
		this._filtro = {};
	}
	obtenerFiltro() {
		return this._filtro;
	}
	guardarFiltro(filtro) {
		this. _filtro = filtro;
	}
}

export default FiltroBuscarFactory;




// WEBPACK FOOTER //
// ./src/busqueda/servicios/buscar.factory.js